import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";


const StarRating = ({ rating }) => {
  return (
    <div style={{ color: "gold" }}>
      {[1, 2, 3, 4, 5].map((star) => {
        if (rating >= star) return "★";       
        else if (rating >= star - 0.5) return "⯪"; 
        else return "☆";                  
      })}
    </div>
  );
};

const card = [
  {
    name: "James Morrison",
    title: "Executive Chef, The Grand Restaurant",
    text: "The quality of the furniture exceeded our expectations...",
    rating: 5,
  },
  {
    name: "Sarah Linden",
    title: "Owner, Brew & Co.",
    text: "We furnished our entire chain of cafés...",
    rating: 4,
  },
  {
    name: "Alexandra Reynolds",
    title: "Interior Designer",
    text: "I've worked with many furniture suppliers...",
    rating: 4.5,
  },
  {
    name: "Michael Chen",
    title: "Hotel Manager",
    text: "The furniture holds up well and looks great...",
    rating: 3,
  },
  {
    name: "Priya Kapoor",
    title: "Director, Vista Interiors",
    text: "Their attention to detail is unmatched.",
    rating: 3.5,
  },
  {
    name: "Carlos Diaz",
    title: "Operations Lead, Café Orbit",
    text: "Highly recommend Artisan Furnish!",
    rating: 5,
  },
];

const Cards = () => {
  const [index, setIndex] = useState(0); 
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Auto-play effect
  React.useEffect(() => {
    if (isAutoPlaying) {
      const interval = setInterval(() => {
        setIndex((prevIndex) => {
          if (prevIndex < card.length - 3) {
            return prevIndex + 1;
          } else {
            return 0; // Loop back to start
          }
        });
      }, 4000); // 4 seconds interval (medium speed)

      return () => clearInterval(interval);
    }
  }, [isAutoPlaying]);

  return (
    <div className="container mt-4 sm:mt-5 mb-4 sm:mb-5 py-4 sm:py-5 px-3 sm:px-4">
      <div className="position-relative">
        <h3 className="text-center mb-2 sm:mb-3 font-bold text-2xl sm:text-3xl md:text-4xl text-gray-900 px-2 sm:px-4">
          What Our Clients Say
        </h3>
        <p className="text-center text-gray-600 mb-4 sm:mb-5 text-sm sm:text-base md:text-lg px-2 sm:px-4 max-w-3xl mx-auto">
          Trusted by the world's finest restaurants and hospitality establishments.
        </p>
      </div>

      {/* Cards */}
      <div className="row mt-3 sm:mt-4 g-3 g-sm-4 justify-content-center">
        {card.slice(index, index + 3).map((item, i) => (
          <div className="col-12 col-sm-6 col-lg-4 mb-3" key={i}>
            <div 
              className="bg-white p-3 sm:p-4 md:p-5 rounded-lg shadow-md border border-gray-200 h-100 hover:shadow-xl transition-all duration-300"
              onMouseEnter={() => setIsAutoPlaying(false)}
              onMouseLeave={() => setIsAutoPlaying(true)}
            >
              <div className="mb-2 sm:mb-3">
                <StarRating rating={item.rating} />
              </div>
              <p className="text-gray-700 mb-3 sm:mb-4 italic text-sm sm:text-base leading-relaxed">
                "{item.text}"
              </p>
              <strong className="text-gray-900 text-base sm:text-lg block mb-1">
                {item.name}
              </strong>
              <div className="text-gray-600 text-xs sm:text-sm">
                {item.title}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Progress Indicators */}
      <div className="d-flex justify-content-center align-items-center gap-2 mt-4 sm:mt-5">
        {[0, 1, 2, 3].map((i) => (
          <button
            key={i}
            onClick={() => {
              setIndex(i);
              setIsAutoPlaying(false);
              setTimeout(() => setIsAutoPlaying(true), 5000);
            }}
            style={{
              width: index === i ? '28px' : '10px',
              height: '10px',
              borderRadius: '5px',
              border: 'none',
              backgroundColor: index === i ? '#374151' : '#D1D5DB',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
              padding: 0
            }}
            aria-label={`Go to testimonial set ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Cards;
